export const WATING_CUSTOMER_REPLY = 'Waiting customer reply';
export const VIEWED_STATUS = 'VIEWED';
export const TICKET_NOTIFICATION = 'TICKET_NOTIFICATION';
export const PICKUP_NOTIFICATION = 'PICKUP_NOTIFICATION';
export const FULFILLMENT_NOTIFICATION = 'FULFILLMENT_NOTIFICATION';
export const DRAFT_ORDER_NOTIFICATION = 'DRAFT_ORDER_NOTIFICATION';
export const BUSINESS_TIER_DOWNGRADED_NOTIFICATION =
  'BUSINESS_TIER_DOWNGRADED_NOTIFICATION';
export const STAR_RESCHEDULED_PICKUP_NOTIFICATION =
  'STAR_RESCHEDULED_PICKUP_NOTIFICATION';
export const CANCELED_RECURRING_PICKUPS_NOTIFICATION =
  'CANCELED_RECURRING_PICKUPS_NOTIFICATION';
export const CANCELED_PICKUPS_WITH_NO_NEW_ORDERS_NOTIFICATION =
  'CANCELED_PICKUPS_WITH_NO_NEW_ORDERS_NOTIFICATION';
export const BUSINESS_PRICE_PLAN_UPGRADED_NOTIFICATION =
  'BUSINESS_PRICE_PLAN_UPGRADED_NOTIFICATION';
export const BUSINESS_PRICE_PLAN_DOWNGRADED_NOTIFICATION_TYPE =
  'BUSINESS_PRICE_PLAN_DOWNGRADED_NOTIFICATION';
export const BUSINESS_PRICE_ENCOURAGEMENT_NOTIFICATION_TYPE =
  'BUSINESS_PRICE_ENCOURAGEMENT_NOTIFICATION_TYPE';
export const BUSINESS_PRICE_NOTIFY_DOWNGRADING_NOTIFICATION_TYPE =
  'BUSINESS_PRICE_NOTIFY_DOWNGRADING_NOTIFICATION_TYPE';
export const DELETED_ORDER_RESTORED = 'DELETED_ORDER_RESTORED';
export const SUCCESSFUL_PICKUP_NOTIFICATION = 'SUCCESSFUL_PICKUP_NOTIFICATION';
export const LOAD_MORE_INITIAL_ITEMS = 3;
export const LOAD_MORE_MAX_ITEMS = 5;
